module.exports = __webpack_public_path__ + "img/risk-level.e302db6a.png";